<template>
    <div class="extended-panel details-panel routed-extended-page">
        <plafond-panel
            v-if="truck"
            class="side-panel-fill"
            :truck="truck"
            @close="goToTruckDetails"
            @driver-change="onDriverChange"
        />
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import PlafondPanel from '@/components/panels/PlafondPanel.vue'
import truckPageGuard from '@/mixins/truckPageGuard'
import driverPrimaryId from '@/functions/driverPrimaryId'

export default {
    name: 'PlafondPage',
    mixins: [truckPageGuard],
    components: { PlafondPanel },
    computed: {
        driver() {
            const id = parseInt(this.$route.params.driver_id)
            const lp = this.truck?.lastpoint
            if (!lp || !id) {
                return null
            }
            return (
                [lp.driver, lp.codriver, lp.last_driver, lp?.rfid?.driver].find(
                    (d) => driverPrimaryId(d) === id
                ) || null
            )
        }
    },
    watch: {
        // Immediate handles the warm-load case (created-equivalent). The reactive
        // re-fire handles cold deep-link load where `truck` is null until bootstrap
        // populates focus_truck.
        truck: { handler: 'resolveDriverOrGoBack', immediate: true }
    },
    methods: {
        ...mapMutations(['setPlafondPanelDriver']),
        resolveDriverOrGoBack() {
            if (!this.truck) {
                return
            }
            if (this.driver) {
                this.setPlafondPanelDriver(this.driver)
            } else {
                this.goToTruckDetails()
            }
        },
        onDriverChange(driver) {
            if (!driver) {
                return
            }
            this.$router.replace({
                name: 'geofleet.driver_plafond',
                params: { id: this.truck.plate, driver_id: driverPrimaryId(driver) }
            })
        }
    }
}
</script>
